import React, { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom'
import { Typography, Box, Skeleton } from '@mui/material';
import breeds from '../../statics/breeds.json'

// Lazy load the ShowMoreText component
const ShowMoreText = lazy(() => import('react-show-more-text'));

function getBreedJson(name) {
    const json_official = breeds.filter(function (breeds) { return breeds.breed === name })[0]
    if (json_official !== undefined) {
        return json_official
    }

    const json_alternative = breeds.filter(function (breeds) { return breeds.alternativnamen == null ? false : breeds.alternativnamen.split(',').includes(name) })[0]
    if (json_alternative !== undefined) {
        return json_alternative
    }

    return null
}

export function RacePageHeader(props) {
    const location = useLocation();
    const name = decodeURI(location.pathname.split('/')[2])
    const breed_json = getBreedJson(name)
    if (breed_json == null){}
    
    return<>
            <Typography variant='h1' mb={2}>
                {breed_json.breed} adoptieren
            </Typography>
            
            <Box sx={{ 
                minHeight: '4.5em',  // Increased to accommodate 3 lines
                '& .content-css': { 
                    lineHeight: '1.5em !important',  // Consistent line height
                    fontSize: '1rem'                  // Consistent font size
                }
            }}>
                <Suspense fallback={<Skeleton variant="text" height={80} />}>
                    <ShowMoreText
                        lines={3}                         // Changed back to 3 lines as requested
                        more="Mehr"
                        less={null}
                        className="content-css"
                        anchorClass="show-more-less-clickable"
                        expanded={false}
                        truncatedEndingComponent={"... "}
                        keepNewLines={false}              // Disable line breaks to maintain consistency
                    >
                       {props.description}
                    </ShowMoreText>
                </Suspense>
            </Box>
        
    </>
}